import React from 'react';
import { useDispatch } from 'react-redux';
import cn from 'classnames';
import {
  useFieldArrayMethods,
  useFormMethods,
} from '../../../../helpers/formManager';
import Btn, { btnTypes } from '../../../../components/btn';
import { fieldNames } from '../../shared/configs/acceptanceForm';
import styles from './index.module.scss';

const DuplicateFieldset = ({ fieldsetName, action, className }) => {
  const { getValues } = useFormMethods();
  const { append } = useFieldArrayMethods();
  const dispatch = useDispatch();

  const handleClick = () => {
    const { [fieldNames.desk.name]: id, ...fieldValues } =
      getValues(fieldsetName);

    append(fieldValues, ({ fieldCount }) => dispatch(action(fieldCount - 1)));
  };

  return (
    <Btn
      onClick={handleClick}
      type={btnTypes.secondary}
      className={cn(styles.root, 'fw-500', className)}
    >
      Дублировать
    </Btn>
  );
};

export default DuplicateFieldset;
